<template>
    <notification-item
        title="Žádost o vstup do týmu"
        :created="data.created"
        :author="data.payload.teamName"
        avatar="/img/myteam/Team-Crest.png"
        :link="{ name: 'teamDetail', params: { id: data.payload.teamId } }"
    >
        <p>Vaše žádost o vstup do týmu <span class="semibold semibold--textgreen"><router-link :to="{ name: 'teamDetail', params: { id: data.payload.teamId } }">{{ data.payload.teamName }}</router-link></span> byla majitelem týmu zamítnuta.</p>
    </notification-item>
</template>

<script>
    import NotificationMixin from '../NotificationMixin';

    export default {
        name: 'TeamRequestDeclined',
        mixins: [NotificationMixin],
    }
</script>
